import { render, staticRenderFns } from "./CustomerSearchSelect.vue?vue&type=template&id=0c24e40d"
import script from "./CustomerSearchSelect.vue?vue&type=script&lang=js"
export * from "./CustomerSearchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports